import { useTranslation } from 'react-i18next';

import { TranslationNamespace } from '../../i18n/types';
import type { TranslationNamespaceType } from '../../i18n/types';

const useTranslate = (
  namespace: TranslationNamespaceType | TranslationNamespaceType[],
) => {
  const { t } = useTranslation(namespace);

  return t;
};

export { useTranslate, TranslationNamespace };

export type Translator = ReturnType<typeof useTranslate>;
export type TranslationKey = Parameters<Translator>['0'];
